<template lang="html">
    <section class="order-window-information">
        <div v-if="orderWindowDate.startDate" class="infosOrderWindow infoStartDate">
            <span class="label">{{ $t("orders.orderWindow.from") }} : </span> {{ orderWindowDate.startDate }} (UTC)
        </div>
        <div v-if="orderWindowDate.endDate" class="infosOrderWindow infoEndDate">
            <span class="label">{{ $t("orders.orderWindow.to") }} : </span> {{ orderWindowDate.endDate }} (UTC)
        </div>
        <div v-if="orderWindowDate.terms && getTranslate(orderWindowDate.terms.description)" class="infosOrderWindow infoTerms">
            <span class="label">{{ $t("orders.orderWindow.description") }} : </span>
            <p>{{ getTranslate(orderWindowDate.terms.description) }}</p>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'order-window-information',
    props: ["orderWindowDate"]
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.order-window-information {
    @extend %second-text;
    .infosOrderWindow {
        margin-bottom: 10px;
        font-family: Roboto, Sans-Serif;
        font-size: 13px;
        .label {
            font-family: Roboto, Sans-Serif;
            font-size: 14px;
        }
        &.infoTerms {
            margin-bottom: 0;
            .label {
                display: block;
            }
            p {
                margin: 5px 0 0 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// orderWindowInformation.vue?d4de1884